export default __webpack_public_path__ + "static/media/ic_boo_30.f488aecf.svg";